export default __webpack_public_path__ + "static/media/intro4.7cba0b3f.mp3";